import React, { useEffect, useState } from 'react';
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import '../../css/KanbanApp.css'

const PostForm = ({ isOpen, onClose, onSubmit, postData, setPostData, isEditing, areaName, postId }) => {
  const [sliderValue, setSliderValue] = useState(postData.percentage || 0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (currentUser) {
      setPostData((prevData) => ({
        ...prevData,
        usuario: currentUser.email,
      }));
    }
  }, [setPostData]);

  useEffect(() => {
    console.log('isEditing:', isEditing);
    console.log('postData:', postData);
  }, [isEditing, postData]);

  useEffect(() => {
    const fetchPostData = async () => {
      if (isEditing && postId && isOpen) {
        setLoading(true);
        const db = getFirestore();
        const postRef = doc(db, areaName, postId);
        const postSnap = await getDoc(postRef);
        if (postSnap.exists()) {
          const data = postSnap.data();
          setPostData(data);
          setSliderValue(data.percentage || 0);
        }
        setLoading(false);
      } else if (!isEditing && isOpen) {
        // Reset form when opening for adding a new post
        setPostData({
          fecha: '',
          obra: '',
          descripcion: '',
          costo: '',
          percentage: 0,
          state: 'Selecciona una opción',
          usuario: postData.usuario || ''
        });
        setSliderValue(0);
      }
    };

    fetchPostData();
  }, [isOpen, isEditing, postId, areaName, setPostData]);

  useEffect(() => {
    console.log('postData actualizado:', postData);
  }, [postData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Submitting form. isEditing:', isEditing);

    if (!postData.state || postData.state === 'Selecciona una opción') {
      alert('Por favor, selecciona un estado válido.');
      return;
    }

    if (onSubmit) {
      onSubmit(e, postData, isEditing);
      onClose();
    }
  };

  const handleCancel = () => {
    setPostData({
      fecha: '',
      obra: '',
      descripcion: '',
      costo: '',
      percentage: 0,
      state: 'Selecciona una opción',
      usuario: postData.usuario // Mantener el usuario actual
    });
    setSliderValue(0);
    onClose();
  };

  const handleSliderChange = (e) => {
    const value = parseInt(e.target.value);
    setSliderValue(value);
    setPostData(prevData => ({ ...prevData, percentage: value }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPostData(prevData => ({
      ...prevData,
      [name]: name === 'percentage' ? Number(value) : value
    }));
  };

  if (!isOpen) return null;

  if (loading) {
    return (
      <div className="modal">
        <div className="modal-content">
          <p>Cargando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="modal">
      <div className="modal-content">
        <h2 className="text-lg font-bold mb-4">{isEditing ? 'Editar Post' : 'Añadir Nuevo Post'}</h2>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div className="space-y-1">
            <div className="form-group">
              <label htmlFor="fecha" className="block text-sm">Fecha:</label>
              <input
                id="fecha"
                name="fecha"
                type="date"
                value={postData.fecha}
                onChange={handleInputChange}
                required
                className="w-full px-2 py-1 border rounded"
              />
            </div>
          </div>
          <div className="space-y-1">
            <div className="form-group">
              <label htmlFor="obra" className="block text-sm">Obra:</label>
              <input
                id="obra"
                name="obra"
                type="text"
                value={postData.obra}
                onChange={handleInputChange}
                required
                className="w-full px-2 py-1 border rounded"
              />
            </div>
          </div>
          <div className="space-y-1">
            <div className="form-group">
              <label htmlFor="descripcion" className="block text-sm">Descripción:</label>
              <textarea
                id="descripcion"
                name="descripcion"
                value={postData.descripcion}
                onChange={handleInputChange}
                required
                className="w-full px-2 py-1 border rounded"
                rows="3"
              />
            </div>
          </div>
          <div className="space-y-1">
            <div className="form-group">
              <label htmlFor="costo" className="block text-sm">Costo:</label>
              <input
                id="costo"
                name="costo"
                type="number"
                step="0.01"
                value={postData.costo}
                onChange={handleInputChange}
                required
                className="w-full px-2 py-1 border rounded"
              />
            </div>
          </div>
          <div className="space-y-1">
            <div className="form-group">
              <label htmlFor="percentage" className="block text-sm">Porcentaje: {postData.percentage}%</label>
              <div className="slider-container">
                <input
                  id="percentage"
                  name="percentage"
                  type="range"
                  min="0"
                  max="100"
                  value={postData.percentage}
                  onChange={handleSliderChange}
                  className="slider"
                />
                <div 
                  className="slider-fill" 
                  style={{ width: `${postData.percentage}%` }}
                ></div>
              </div>
            </div>
          </div>
          <div className="space-y-1">
            <div className="form-group">
              <label htmlFor="state" className="block text-sm">Estado:</label>
              <select
                id="state"
                name="state"
                value={postData.state}
                onChange={handleInputChange}
                required
                className="w-full px-2 py-1 border rounded"
              >
                <option value="Selecciona una opción" disabled>
                  Selecciona una opción
                </option>
                <option value="Finalizado">Finalizado</option>
                <option value="En proceso">En proceso</option>
                <option value="A iniciar">A iniciar</option>
              </select>
            </div>
          </div>
          <div className="modal-buttons">
            <button type="submit" className="bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600">
              {isEditing ? 'Actualizar' : 'Agregar'}
            </button>
            <button type="button" onClick={handleCancel} className="bg-gray-300 text-gray-800 px-4 py-1 rounded hover:bg-gray-400 ml-2">
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PostForm;

